import { AppUser } from "@aveespa/common/models/auth/app-user.interface";

/* eslint-disable */
export const user = {
    id: 'cfaad35d-07a3-4447-a6c3-d8c3d54fd5df',
    name: 'Brian Hughes',
    email: 'hughes.brian@company.com',
    avatar: 'images/avatars/brian-hughes.jpg',
    status: 'online',
};

// AppUsers list for Admin > Users page (Delta)
export const appUsers: AppUser[] = [
  {
    uid: 'u_admin_1',
    firstName: 'Bea',
    lastName: 'Rojas',
    displayName: 'Bea Rojas',
    email: 'bea@prism.com',
    phone: '+1 (555) 555-1000',
    tenantId: 'aveespa',
    role: 'system_admin',
    requestAccess: { departmentIds: ['aba', 'is'], groupIds: [] },
    queueIds: [],
    isActive: true,
    hasOfficeAccess: true,
    lastLoginDate: Date.now() - 1000 * 60 * 25,
    createdAt: Date.now() - 1000 * 60 * 60 * 24 * 90,
    createdBy: {
        uid: 'u_admin_0',
        displayName: 'System Admin',
        firstName: 'System',
        lastName: 'Admin',
        email: 'admin-portal@aveespa.com',
    },
    recordStatus: 'active',
  },
  {
    uid: 'u_office_1',
    firstName: 'Ana',
    lastName: 'Martinez',
    displayName: 'Ana Martinez',
    hasOfficeAccess: true,
    email: 'ana.office@prism.com',
    tenantId: 'aveespa',
    role: 'office_staff',
    requestAccess: { departmentIds: ['aba'], groupIds: [] },
    queueIds: [],
    isActive: true,
    lastLoginDate: Date.now() - 1000 * 60 * 60 * 8,
    createdAt: Date.now() - 1000 * 60 * 60 * 24 * 30,
        createdBy: {
        uid: 'u_admin_0',
        displayName: 'System Admin',
        firstName: 'System',
        lastName: 'Admin',
        email: 'admin-portal@aveespa.com',
    },
    recordStatus: 'active',
  },
  {
    uid: 'u_field_1',
    firstName: 'Carlos',
    lastName: 'Lopez',
    displayName: 'Carlos Lopez',
    email: 'carlos.field@prism.com',
    tenantId: 'aveespa',
    role: 'field_staff',
    hasOfficeAccess: false,
    requestAccess: { departmentIds: ['is'], groupIds: [] },
    queueIds: [],
    isActive: false,
    lastLoginDate: Date.now() - 1000 * 60 * 60 * 48,
    createdAt: Date.now() - 1000 * 60 * 60 * 24 * 60,
        createdBy: {
        uid: 'u_admin_0',
        displayName: 'System Admin',
        firstName: 'System',
        lastName: 'Admin',
        email: 'admin-portal@aveespa.com',
    },
    recordStatus: 'active',
  },
];